export enum customerReducerActionTypes {
  UPDATE_CUSTOMER = 'CUSTOMER_UPDATE_CUSTOMER',
  UPDATE_FORM_VALID = 'CUSTOMER_UPDATE_FORM_VALID',
  UPDATE_PRISTINE = 'CUSTOMER_UPDATE_PRISTINE',
}

interface CustomerUpdateCustomerAction {
  type: customerReducerActionTypes.UPDATE_CUSTOMER;
  payload: Customer;
}

interface CustomerUpdateFormValidAction {
  type: customerReducerActionTypes.UPDATE_FORM_VALID;
  payload: boolean;
}

interface CustomerUpdatePristineAction {
  type: customerReducerActionTypes.UPDATE_PRISTINE;
  payload: boolean;
}

export type CustomerReducerAction =
  | CustomerUpdateCustomerAction
  | CustomerUpdateFormValidAction
  | CustomerUpdatePristineAction;

export interface Customer {
  id: string;
  firstname?: string | null;
  lastname?: string | null;
  email?: string | null;
  phone?: string | null;
  address?: {
    country?: string | null;
  } | null;
  birthDate?: string;
  pin?: string;
}

export interface CustomerReducerState {
  customer: Customer;
  formValid: boolean;
  pristine: boolean;
}

export const customerReducerInitialState: CustomerReducerState = {
  customer: {
    id: '',
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    birthDate: '',
    pin: '',
    address: {
      country: '',
    },
  },
  formValid: false,
  pristine: true,
};

const customerReducer = (
  state: CustomerReducerState,
  action: CustomerReducerAction
): CustomerReducerState => {
  switch (action.type) {
    case customerReducerActionTypes.UPDATE_CUSTOMER: {
      return {
        ...state,
        customer: action.payload,
      };
    }
    case customerReducerActionTypes.UPDATE_FORM_VALID: {
      return {
        ...state,
        formValid: action.payload,
      };
    }
    case customerReducerActionTypes.UPDATE_PRISTINE: {
      return {
        ...state,
        pristine: action.payload || false,
      };
    }
    default:
      return state;
  }
};

export default customerReducer;
